import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import GeoIcon from "src/assets/static/images/geoLangIcon.svg";
import EngIcon from "src/assets/static/images/icon-eng.svg";
import { ReactComponent as DownArrow } from "src/assets/static/images/downarrow.svg";
import actions from "src/store/common/actions";

const LanguageSwitcher = () => {
  const lang = useSelector((state) => state.common.lang);
  const dropdown3Ref = useRef(null);

  const dispatch = useDispatch();

  return (
    <button
      className="language-switcher"
      onClick={() => {
        dispatch(actions.setLanguage(lang === "ge" ? "en" : "ge"));
        localStorage.setItem("lang", lang === "ge" ? "en" : "ge");
      }}
    >
      {lang === "ge" ? "Eng" : "ქარ"}
    </button>
  );
};

export default LanguageSwitcher;
